import { RigidBody } from "@react-three/rapier";
import RectangleBlock from "../block/RectangleBlock.jsx";
import AngleBlock from "../block/AngleBlock.jsx";
import { COLORS } from "../../../constants/colors";

const RaceTurn = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  return (
    <group position={position} rotation={rotation}>
      <RigidBody type="fixed" friction={1} restitution={0} ccd={false}>
        <mesh>
          <boxGeometry args={[6, 0.01, 6]} />
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </mesh>
      </RigidBody>
      <RectangleBlock position={[2.8, 0.6, 0]} rotation={[0, 0, 0]} />
      <RectangleBlock
        position={[0, 0.6, -2.8]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <AngleBlock position={[-2.8, 0.6, 2.8]} />
    </group>
  );
};

export default RaceTurn;
